import { Gavel } from "lucide-react";
import GenericPracticePage from "@/components/GenericPracticePage";
import heroImage from "@/assets/foreclosure-eviction.jpg";

const ForeclosuresEvictions = () => {
  const mainContent = (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl font-bold mb-6">Foreclosure Defense & Eviction Services</h2>
          <p className="text-lg text-muted-foreground">
            Legal representation for foreclosure defense, eviction proceedings, and landlord-tenant disputes in Houston, Texas. We protect property owners and tenants through experienced litigation and negotiation.
          </p>
        </div>
      </div>
    </section>
  );
  return <GenericPracticePage title="Foreclosures & Evictions" subtitle="Protect Your Property Rights" icon={<Gavel className="h-16 w-16 text-accent" />} mainContent={mainContent} heroImage={heroImage} />;
};
export default ForeclosuresEvictions;